import { IconButton, Shadow, Text, Tooltip, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Skeleton } from 'native-base';
import React from 'react';

import { TableContentItemStatus } from '../../../../../../components/TableContent/status';
import { messageError } from '../../../../utils/constants';

import type { LayoutItemProps } from '.';

export const Mobile: React.FC<Partial<LayoutItemProps>> = ({
  data,
  onRemove,
  isDisabledButton,
  isLoading,
}) => {
  return (
    <Shadow level={2} borderRadius={BoxRadius.sm}>
      <VStack p={Spacing['inline.xxs']} space={Spacing['inset.xs']} borderRadius={BoxRadius.sm}>
        <HStack alignItems="center" justifyContent="space-between">
          <VStack space={Spacing['stack.quarck']}>
            <Text color="neutral.darkest" isLoading={isLoading} {...(isLoading && { w: '180px' })}>
              {data?.customerName || messageError}
            </Text>
            <HStack alignItems="center" space={Spacing['inline.nano']}>
              <Text fontSize={Typography['fontsize.xs']} color="neutral.dark">
                Conta
              </Text>
              <Text
                fontSize={Typography['fontsize.xs']}
                color="neutral.dark"
                isLoading={isLoading}
                {...(isLoading && { w: '80px' })}>
                {data?.sinacorAccount || messageError}
              </Text>
            </HStack>
          </VStack>
          <IconButton
            testId="remove-item"
            borderRadius={BoxRadius.sm}
            w={Spacing['inline.sm']}
            h={Spacing['inline.sm']}
            iconColor={Color['feedback.error.default']}
            icon="Trash"
            isDisabled={isDisabledButton || isLoading}
            onPress={() => onRemove && data?.id && onRemove(data?.id, data?.basketCustomerOfferId)}
            p={0}
            iconSize="xs"
          />
        </HStack>
        <VStack space={Spacing['inline.nano']}>
          <HStack
            w="full"
            alignItems="center"
            justifyContent="space-between"
            space={Spacing['stack.nano']}>
            <Text fontSize={Typography['fontsize.xs']} color="neutral.black">
              Produto
            </Text>
            <Text color="neutral.darkest" isLoading={isLoading} {...(isLoading && { maxW: '1/2' })}>
              {data?.productType || messageError}
            </Text>
          </HStack>
          <HStack
            w="full"
            alignItems="center"
            justifyContent="space-between"
            space={Spacing['stack.nano']}>
            <Text fontSize={Typography['fontsize.xs']} color="neutral.black">
              Ativo
            </Text>
            <Tooltip label={data?.assetName || messageError} isDisabled={isLoading}>
              <VStack>
                <Text
                  isLoading={isLoading}
                  color="neutral.darkest"
                  maxW="220px"
                  noOfLines={1}
                  {...(isLoading && { w: '160px' })}>
                  {data?.assetName || messageError}
                </Text>
              </VStack>
            </Tooltip>
          </HStack>
          <HStack
            w="full"
            alignItems="center"
            justifyContent="space-between"
            space={Spacing['stack.nano']}>
            <Text fontSize={Typography['fontsize.xs']} color="neutral.black">
              Valor da boleta
            </Text>
            <Text color="neutral.darkest" isLoading={isLoading} {...(isLoading && { maxW: '1/2' })}>
              {data?.ticketAmount || messageError}
            </Text>
          </HStack>
          {/* <HStack
            w="full"
            alignItems="center"
            justifyContent="space-between"
            space={Spacing['stack.nano']}>
            <Text fontSize={Typography['fontsize.xs']} color="neutral.black">
              Valor liq. estimado
            </Text>
            <Text color="neutral.darkest" isLoading={isLoading} {...(isLoading && { maxW: '1/2' })}>
              {data?.estimatedNetValue || messageError}
            </Text>
          </HStack> */}
          <HStack
            w="full"
            alignItems="center"
            justifyContent="space-between"
            space={Spacing['stack.nano']}>
            <Text fontSize={Typography['fontsize.xs']} color="neutral.black">
              Status
            </Text>
            {isLoading ? (
              <Skeleton w="1/2" h={Typography['fontsize.md']} borderRadius={BoxRadius.sm} />
            ) : (
              <TableContentItemStatus
                maxW={{ sm: '220px', lg: '110px' }}
                basketAdvisorStatus={data?.status}
                customTooltipLabel={data?.customError}
              />
            )}
          </HStack>
        </VStack>
      </VStack>
    </Shadow>
  );
};
